"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/* eslint-disable */

/* Generated file. Do not edit directly. */
var _default = {
  "coreBlue10": "#b3cdde",
  "coreBlue20": "#8ab0c7",
  "coreBlue30": "#598aaa",
  "coreBlue40": "#255f82",
  "coreBlue50": "#013d5b",
  "coreBlue60": "#10253f",
  "coreBlue70": "#00132b",
  "interactionBlue10": "#e1f5ff",
  "interactionBlue20": "#81d4fe",
  "interactionBlue30": "#3abcfd",
  "interactionBlue40": "#028ed4",
  "interactionBlue50": "#0276b1",
  "interactionBlue60": "#026597",
  "interactionBlue70": "#014e74",
  "interactionGreen10": "#d9fad1",
  "interactionGreen20": "#a1f28c",
  "interactionGreen30": "#4bc92c",
  "interactionGreen40": "#30a512",
  "interactionGreen50": "#25810e",
  "interactionGreen60": "#1e6a0b",
  "interactionGreen70": "#185309",
  "interactionRed10": "#ffe5e6",
  "interactionRed20": "#ff8082",
  "interactionRed30": "#fb5053",
  "interactionRed40": "#f23639",
  "interactionRed50": "#cc2427",
  "interactionRed60": "#ba2629",
  "interactionRed70": "#a3282b",
  "accentLightBlue10": "#c0e7f3",
  "accentLightBlue20": "#9fdbef",
  "accentLightBlue30": "#78d0eb",
  "accentLightBlue40": "#4bc7e7",
  "accentLightBlue50": "#00c0e5",
  "accentLightBlue60": "#00afd4",
  "accentLightBlue70": "#00a3c4",
  "accentLightBlue80": "#007f9b",
  "accentGreen10": "#dae8d8",
  "accentGreen20": "#bad4b4",
  "accentGreen30": "#9ac497",
  "accentGreen40": "#7bb475",
  "accentGreen50": "#59a545",
  "accentGreen60": "#309042",
  "accentGreen70": "#008140",
  "accentGreen80": "#007138",
  "accentGreen90": "#005128",
  "accentYellow10": "#fff1d0",
  "accentYellow20": "#ffe7a7",
  "accentYellow30": "#fedc7d",
  "accentYellow40": "#fbd44d",
  "accentYellow50": "#f9c606",
  "accentYellow60": "#f1ba0d",
  "accentYellow70": "#e8ad11",
  "accentRed10": "#fcd5d1",
  "accentRed20": "#f8ada4",
  "accentRed30": "#ec837a",
  "accentRed40": "#e05752",
  "accentRed50": "#cc2427",
  "accentRed60": "#ba2629",
  "accentRed70": "#a3282b",
  "digitalGray10": "#f4f4f4",
  "digitalGray20": "#d4d4d4",
  "digitalGray80": "#7d7d7d",
  "digitalGray90": "#696969",
  "digitalGray100": "#525252",
  "digitalGray110": "#3d3d3d",
  "digitalGray120": "#141414",
  "gray10": "#f4f4f4",
  "gray20": "#ebebeb",
  "gray30": "#e4e5e5",
  "gray40": "#d7d7d7",
  "gray50": "#cecfcd",
  "gray60": "#c3c4c2",
  "gray70": "#afb0af",
  "gray80": "#7d7d7d",
  "gray90": "#676868",
  "gray100": "#515252",
  "charcoal10": "#bcbfc7",
  "charcoal20": "#8b939e",
  "charcoal30": "#606a77",
  "charcoal40": "#3e4b59",
  "charcoal50": "#1c2b39",
  "charcoal60": "#0e1d2b",
  "charcoal70": "#141414",
  "transparent": "rgba(0,0,0,0)",
  "white": "#fff",
  "actionPrimary": "#0276b1",
  "actionPrimaryHover": "#026597",
  "actionPrimaryActive": "#014e74",
  "actionSecondary": "#696969",
  "actionSecondaryHover": "#525252",
  "actionSecondaryActive": "#3d3d3d",
  "feedbackInformationPrimary": "#0276b1",
  "feedbackInformationSecondary": "#e1f5ff",
  "feedbackSuccessPrimary": "#25810e",
  "feedbackSuccessSecondary": "#d9fad1",
  "feedbackErrorPrimary": "#cc2427",
  "feedbackErrorSecondary": "#ffe5e6",
  "feedbackWarningPrimary": "#f9c606",
  "feedbackWarningSecondary": "#fff1d0",
  "statusDefault": "#d4d4d4",
  "statusInProgress": "#255f82",
  "statusComplete": "#008140",
  "statusFailed": "#cc2427",
  "textDark": "#141414",
  "textLight": "#fff",
  "stateDisabledPrimary": "#d4d4d4",
  "stateDisabledSecondary": "#f4f4f4",
  "stateDisabledTertiary": "#7d7d7d",
  "stateErrorPrimary": "#cc2427",
  "stateHoverPrimary": "#0276b1",
  "stateFocusPrimary": "#0276b1",
  "stateSelectedPrimary": "#0276b1",
  "dividerDark": "#d4d4d4",
  "dividerLight": "#fff",
  "globalBackgroundLightPrimary": "#fff",
  "globalBackgroundLightSecondary": "#f4f4f4",
  "globalBackgroundDarkPrimary": "#3d3d3d",
  "globalBackgroundDarkSecondary": "#525252"
};
exports["default"] = _default;